<template>
  <li class="">
    <div class="usp">
      <p>
        <checkmark/>
        <br>
        <slot></slot>
      </p>
    </div>
  </li>
</template>

<script>
import Checkmark from './Checkmark.vue';

export default {
  name: 'UPS.vue',
  components: { Checkmark },
};
</script>

<style scoped>
  .usp > p {
    font-weight: bold;
    font-size: 13px;
    color: #F7F7F7;
    text-align: center;
    line-height: 25px;
  }
</style>
